import {JSONModel, jsonProperty} from "../json.model";

export type AuthDetailFlags = {
  [key: string]: boolean;
};

export class AuthDetailModel extends JSONModel {
  @jsonProperty("string") uid: string;
  @jsonProperty("string") id: string;
  @jsonProperty("string") fullName: string;
  @jsonProperty("string") emailAddress: string;
  @jsonProperty("string") userName: string;
  @jsonProperty("boolean") readOnly: boolean;
  @jsonProperty(["string"]) roles: string[];
  @jsonProperty("flags") roleFlags: AuthDetailFlags;
  @jsonProperty(["string"]) privileges: string[];
  @jsonProperty("flags") privilegeFlags: AuthDetailFlags;
  @jsonProperty("boolean") isSwitched: boolean;
}
